<template>

<core-modal-setting title="Type" :value="valueText" :is-locked="isLocked" placeholder="Not selected">
        
    <core-input-checklist 
        :options="options"
        v-model="internalValue"
    />

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'

export default {

    mixins: [mixSetting],

    computed: {

        options: function() {

            return [{
				value: 1,
				text: 'List',
				description: 'Table layout with curated fields.'
			}, {
				value: 2,
				text: 'Sheet',
				description: 'Spreadsheet layout with raw fields.'
			}, {
				value: 3,
				text: 'Cards',
				description: 'Grid layout with curated fields.'
			}, {
				value: 4,
				text: 'Gallery',
				description: 'Thumbnail layout with minimal fields.'
			}]

        }

    }

}

</script>

<style scoped>

</style>